import React from 'react'

import { makeStyles } from '@material-ui/core'

import { ClientDetail, TableClients, SearchBox } from './components'
import useContract from 'hooks/useContract'
import Footer from './../Footer'
import styles from './styles'

const useStyles = makeStyles(styles)

const Client = () => {
  const classes = useStyles()
  const { data, nextStep } = useContract()
  const [name, setName] = React.useState('')

  const handleSearch = name => setName(name)

  const handleClickNextButton = () => nextStep()

  return (
    <>
      <div className={classes.container}>
        <SearchBox onSearch={handleSearch} />

        <div className={classes.containerClient}>
          <div className={classes.table}>
            <TableClients name={name} />
          </div>
          <div className={classes.detail}>
            <ClientDetail />
          </div>
        </div>
      </div>

      <Footer
        nextButtonText="Continuar"
        nextButtonProps={{
          disabled: !data.customer,
          onClick: handleClickNextButton,
        }}
      />
    </>
  )
}

export default Client
